export enum LocalEvent {
  TAB_ACTIVATED = 'TAB_ACTIVATED',
  BASE_INFO_UPDATE = 'BASE_INFO_UPDATE',
  WORK_INFO_UPDATE = 'WORK_INFO_UPDATE',
  RESIGN_INFO_UPDATE = 'RESIGN_INFO_UPDATE',
  PERFORMANCE_DRAWER_UPDATE = 'PERFORMANCE_DRAWER_UPDATE',
  PERFORMANCE_DETAIL_UPDATE = 'PERFORMANCE_DETAIL_UPDATE',
  PERFORMANCE_DRAWER_TAB_CHANGE = 'PERFORMANCE_DRAWER_TAB_CHANGE',
}
